module.exports = __webpack_public_path__ + "img/ardr.7ab213e9.svg";